function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutContainer',_vm._l((_vm.menu),function(ref,index){
var handle = ref.handle;
var rest = objectWithoutProperties( ref, ["handle"] );
var item = rest;
return _c('OmtRow',{key:index,attrs:{"mb":"24px"}},[_c('CardTile',_vm._b({on:{"click":handle}},'CardTile',item,false))],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }